import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { MapPin, Plus, Trash2, X } from 'lucide-react';

const AdminLocations = ({
  locations,
  newLocationName,
  setNewLocationName,
  newLocationAddress,
  setNewLocationAddress,
  onAddLocation,
  onDeleteLocation,
  onClose
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-background-paper border border-white/10 rounded-sm p-8 mb-12"
    >
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-heading text-2xl font-bold">
          MANAGE <span className="text-primary">LOCATIONS</span>
        </h2>
        <Button variant="ghost" onClick={onClose} data-testid="close-locations-btn">
          <X className="w-5 h-5" />
        </Button>
      </div>

      {/* Add New Location Form */}
      <form onSubmit={onAddLocation} className="flex gap-4 mb-6">
        <div className="flex-1">
          <Input
            placeholder="Location name (e.g., Yoga Room)"
            value={newLocationName}
            onChange={(e) => setNewLocationName(e.target.value)}
            className="bg-background border-white/10"
            data-testid="new-location-name-input"
          />
        </div>
        <div className="flex-1">
          <Input
            placeholder="Address (optional)"
            value={newLocationAddress}
            onChange={(e) => setNewLocationAddress(e.target.value)}
            className="bg-background border-white/10"
            data-testid="new-location-address-input"
          />
        </div>
        <Button type="submit" className="bg-success hover:bg-success/80" data-testid="add-location-btn">
          <Plus className="w-4 h-4 mr-2" />
          ADD
        </Button>
      </form>

      {/* Locations List */}
      <div className="space-y-2">
        <p className="text-xs uppercase tracking-wider text-neutral-500 mb-3">
          {locations.length} Location{locations.length !== 1 ? 's' : ''}
        </p>
        {locations.map((loc, index) => (
          <div
            key={loc.location_id}
            className="flex justify-between items-center bg-background border border-white/10 rounded-sm p-4"
            data-testid={`location-item-${index}`}
          >
            <div className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-primary" />
              <div>
                <p className="font-bold">{loc.name}</p>
                {loc.address && <p className="text-sm text-neutral-400">{loc.address}</p>}
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              className="border-error text-error hover:bg-error hover:text-white"
              onClick={() => onDeleteLocation(loc.location_id, loc.name)}
              data-testid={`delete-location-btn-${index}`}
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div>
      
      <p className="text-xs text-neutral-500 mt-4">
        Note: Locations that are currently assigned to classes cannot be deleted.
      </p>
    </motion.div>
  );
};

export default AdminLocations;
